module.exports = function () {
    return Promise; // eslint-disable-line
};
